export enum DomainPackageState {
	PENDING = 0,
	REFUSED = 1,
	ACCEPTED = 2,
	CANCELED = 3,
	RETIRED = 4,
	RETIRED_DEFINITELY = 5
}
